import React from 'react'
import TabSearch from '../../NewComponent/TabSearch/tabSearch'
import SelectComp from '../../NewComponent/Select/Select';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import {Actions} from '../../Action/index';
import { keyTermTypeOptions } from '../../Constants';
import { Spin } from 'antd';

export default function KeyTermFilters() {
    const termState = useSelector((state) => state.keyTerm);
    const userState = useSelector((state) => state.user);
    const dispatch = useDispatch();
    // console.log(userState.expertTopics);
    const {
      keyTermDomainUpdate,
      keyTermSearchQueryUpdate,
      keyTermDataIsLoading,
      keyTermDataUpdate,
      keyTermDataPageNoUpdate,
      getkeyTagPayload,
      keyTermWordsChange,
      answerUuidSentToUpdateViewCount,
      allAnswerUuidEmptyForScrollCount,
    } = bindActionCreators(Actions, dispatch);
    const onChangeText =(e)=>{
        keyTermSearchQueryUpdate(e.target.value)
    }
    const onChangeDomain =(e)=>{
        keyTermDomainUpdate(e)
    }
    const onChangeWord =(e)=>{
        keyTermWordsChange(e);
    }
    const filterDomain=(arr)=>{
        let options = [{label:'All',value:'All'}];
        arr.map((ar, ind)=>{
            options.push({label:ar.name, value:ar.name});
        });
        return options;
    }
  return (
    <>
    <div style={{display:'flex', justifyContent:'space-between',alignItems:'center', flexWrap:'wrap'}}>
            <div className='mt-1'><TabSearch val={termState.searchQuery} size={'large'} onChangeFunc={onChangeText} /></div>
            <div style={{display:'flex'}}>
            <div className='mt-1'><SelectComp onChangeFunc={onChangeWord} isString={false} val={termState.words} options={keyTermTypeOptions} width={'150px'}  size={'large'}/></div>
            &nbsp;&nbsp;
            <div className='mt-1'><SelectComp onChangeFunc={onChangeDomain} isString={false} val={termState.selectedDomain} options={filterDomain(userState.expertTopics)} width={'260px'}  size={'large'}/></div>
            </div>
        </div>
    </>
  )
}
